import { useLocale } from '../../../../i18n';
import { caribbeanCountries } from '../constants/caribbeanCountries';

const useIsCaribbean = () => {
  const { userCountry } = useLocale();
  return caribbeanCountries.includes(userCountry);
};

export default useIsCaribbean;
